module.exports = __webpack_public_path__ + "img/icon-01.0bd20745.svg";